import { useScanDeviceApiGetQuery, type SwrConfig } from '@hooks/api';
import type { ScanDeviceMdmGroup } from 'types/api';

export const useMdmGroups = (swrConfig?: SwrConfig<ScanDeviceMdmGroup[]>) => {
  return useScanDeviceApiGetQuery<ScanDeviceMdmGroup[]>('/mdm/groups', swrConfig);
};
